import { useEffect } from 'react'

const useChatInitialization = ({
  chatFlowType,
  language,
  hasCompletedNewUserFlow,
  effectiveAgentId,
  agentFullName,
  messages,
  dispatch,
  resetChat,
  setFlowType,
  setMessages,
  setQuestionStep,
  translations,
  getWelcomeMessage,
  getLocalizedWelcomeMessage,
  getMessageId,
  getTime,
}) => {
  useEffect(() => {
    let effectiveFlowType = chatFlowType
    let effectiveMessages = messages

    if (
      chatFlowType === 'new' &&
      hasCompletedNewUserFlow &&
      effectiveMessages.length === 0
    ) {
      dispatch(resetChat())
      dispatch(setFlowType('existing'))

      effectiveFlowType = 'existing'
      effectiveMessages = []
    }

    if (!effectiveFlowType) {
      effectiveFlowType = effectiveAgentId ? 'existing' : 'new'
      dispatch(setFlowType(effectiveFlowType))
    }

    // Wait for the language selected during authorization before creating the
    // first chatbot message. The authorization page loads translations into
    // Redux asynchronously, so initializing earlier would permanently add the
    // English fallback message.
    if (effectiveMessages.length === 0 && !translations) return

    if (effectiveMessages.length === 0) {
      dispatch(setQuestionStep(-1))

      const welcomeMessage =
        getLocalizedWelcomeMessage?.({
          isExistingUser: effectiveFlowType === 'existing',
          agentFullName,
        }) ||
        getWelcomeMessage({
          isExistingUser: effectiveFlowType === 'existing',
          agentFullName,
        })

      dispatch(
        setMessages([
          {
            id: getMessageId(),
            from: 'ai',
            text: welcomeMessage,
            showUserProfile: effectiveFlowType === 'existing',
            time: getTime(),
          },
        ]),
      )
    } else if (
      effectiveMessages.length === 1 &&
      effectiveMessages[0]?.from === 'ai'
    ) {
      const welcomeMessage =
        getLocalizedWelcomeMessage?.({
          isExistingUser: effectiveFlowType === 'existing',
          agentFullName,
        }) ||
        getWelcomeMessage({
          isExistingUser: effectiveFlowType === 'existing',
          agentFullName,
        })

      const showUserProfile = effectiveFlowType === 'existing'

      if (
        effectiveMessages[0].text !== welcomeMessage ||
        effectiveMessages[0].showUserProfile !== showUserProfile
      ) {
        dispatch(
          setMessages([
            {
              ...effectiveMessages[0],
              text: welcomeMessage,
              showUserProfile,
            },
          ]),
        )
      }
    }
  }, [
    chatFlowType,
    language,
    hasCompletedNewUserFlow,
    effectiveAgentId,
    agentFullName,
    messages,
    translations,
  ])
}

export default useChatInitialization
